import { Pipe, PipeTransform } from "@angular/core";


@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
    transform(value: string): string {
        return value == '0.00' ? "Gratuíto" : "R$ ".concat(value.replace('.', ','));
    }
}